import { makeStyles, tokens } from '@fluentui/react-components';
import { linkGreen } from '../Shared/Shared';

export const useLevelOneAccordionPanelStyles = makeStyles({
  dropdownList: {
    columnCount: 2,
    margin: 0,
    padding: 0,
  },
  dropDownItem: {
    display: 'block',
    breakInside: 'avoid',
    listStyleType: 'none',
    paddingTop: '16px',
  },
  roleItem: {
    color: tokens.colorNeutralForeground3,
  },
  container: {
    borderTopStyle: 'solid',
    borderTopColor: tokens.colorNeutralStrokeDisabled,
    borderTopWidth: '1px',
    paddingBottom: '16px',
  },
  disciplineHeader: {
    display: 'block',
  },
  link: {
    textDecorationLine: 'underline',
    color: linkGreen,
    display: 'flex',
    flexDirection: 'column',
    gridGap: '4px',
  },
  textContents: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: '4px',
  },
  dropdownFont: {
    fontSize: '14px',
    fontWeight: '400px',
  },
  skeletonContainer: {
    marginTop: '20px',
    marginBottom: '8px',
    columnGap: '16px',
    rowGap: '12px',
  },
});
